module.exports = __webpack_public_path__ + "static/media/3-pin.32a974e0.svg";